<p class="form-alert-message--{{ type }}" *ngIf="message">
  <em *ngIf="iconClass" class="form-alert-message-icon fas {{ iconClass }}"></em>
  {{ message | translate: values }}
</p>